export default __webpack_public_path__ + "static/media/homevilla1.c314facb.jpg";